import { ReactNode } from 'react';
import cn from 'classnames';
import { Tooltip } from 'react-tooltip';

import styles from './RadioList.module.scss';

export interface FilterRadioItem {
  id?: string;
  name: string;
  value: string;
  description?: ReactNode;
  icon?: ReactNode;
  disabled?: boolean;
  tooltipText?: string;
}

export interface FilterRadioListProps {
  items: FilterRadioItem[];
  selectedValue: string;
  onChange: (value: string) => void;
  name: string;
  className?: string;
}

export const RadioList: React.FC<FilterRadioListProps> = ({
  items,
  selectedValue,
  onChange,
  name,
  className,
}) => {
  return (
    <div className={cn(styles.radioList, className)}>
      {items.map((item, index) => {
        const isChecked = selectedValue === item.value;
        const tooltipId = item.disabled && item.tooltipText ? `${name}-${item.value}-tooltip` : undefined;
        return (
          <label
            key={`${item.value}-${index}`}
            className={cn(styles.radioItem, {
              [styles.disabled]: item.disabled,
              [styles.checked]: isChecked,
              [styles.hasDescription]: Boolean(item.description),
            })}
            data-tooltip-id={tooltipId}
            data-tooltip-content={item.tooltipText}
          >
            <span className={cn(styles.radioWrapper, { [styles.radioWrapperChecked]: isChecked })}>
              <input
                type="radio"
                name={name}
                value={item.value}
                checked={isChecked}
                onChange={(e) => onChange(e.target.value)}
                disabled={item.disabled}
                className={styles.radioInput}
              />
              <span className={styles.radioCustom} />
            </span>
            {item.icon && <span className={styles.icon}>{item.icon}</span>}
            <span className={styles.label}>
              {item.name}
              {item.description && <span className={styles.description}>{item.description}</span>}
            </span>
            {tooltipId && (
              <Tooltip
                id={tooltipId}
                place="bottom"
                className={styles.tooltip}
              />
            )}
          </label>
        );
      })}
    </div>
  );
};
